import { queryOptions } from "@tanstack/react-query";
import type { RecentInvoicesResponse } from "@/app/billing/types";
import { getCoordinatorApi } from "@/lib/api";
import { billingKeys } from "./query-keys";

const fetchRecentInvoices = async ({
  organizationId,
}: {
  organizationId: string;
}): Promise<RecentInvoicesResponse> => {
  const api = getCoordinatorApi({ organizationId });
  const { data } = await api.get<RecentInvoicesResponse>(
    "/billing/recent_invoices"
  );

  return data;
};

export const recentInvoicesQueryOptions = ({
  organizationId,
}: {
  organizationId: string;
}) =>
  queryOptions<RecentInvoicesResponse>({
    queryKey: billingKeys.recentInvoice(organizationId),
    queryFn: () => fetchRecentInvoices({ organizationId }),
  });
